import { Amplify } from 'aws-amplify';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import ErrorBoundary from '@/components/ErrorBoundary.jsx';

import { AWSProvider } from '@/context/AWSContext.jsx';
import { ThemeProvider } from '@/context/theme/ThemeProvider.jsx';

import App from './App.tsx';
import awsExports from './aws-exports.js';
import store from './store.js';

Amplify.configure({
    ...awsExports,
    oauth: {
        ...awsExports.oauth,
        redirectSignIn: `${window.location.origin}/`,
        redirectSignOut: `${window.location.origin}/`,
    },
});

createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
        <AWSProvider>
            <ErrorBoundary>
                <ThemeProvider>
                    <App />
                </ThemeProvider>
            </ErrorBoundary>
        </AWSProvider>
    </Provider>
);
